import React, {useState, useEffect, useReducer} from 'react';
import SectionHandler from "./sections/SectionHandler";
import FirstSection from "./sections/FirstSection";
import {Page} from "./models/Page";
import PageList from "./PageList";
import {Paginator} from "./models/Paginator";
import {Comment} from "./models/Comment";
import {Action, defaultReducer, State, ToggleName} from "./State";
import SignIn, {SignInFetchers} from "./SignIn";
import Header from "./Header";
import {User} from "./models/User";
import './Main.css'

export type StateRoot = State & {
    pagesRecent: Paginator<Page>;
    pagesByPrice: Paginator<Page>;
}

export type ActionRoot = Action |
    { type: 'append-pages-recent', payload: Page[] } |
    { type: 'append-pages-by-price', payload: Page[] }
    ;

function Root(props: { pages_recent: Page[], pages_recent_next_token:string,
    pages_by_price: Page[], pages_by_price_next_token: string, user: User }) {
    console.log("props.pages_recent", props.pages_recent);


    const initialState: StateRoot = {
        codeVerifying: "",
        emailVerifying: "",
        pagesRecent: new Paginator<Page>(Page, props.pages_recent, null,
            "/pages/recent.json", "pages", props.pages_recent_next_token,
            null, null),
        pagesByPrice: new Paginator<Page>(Page, props.pages_by_price, null,
            "/pages/by_price.json", "pages", props.pages_by_price_next_token,
            null, null),
        toggles: new Set<ToggleName>,
        user: props.user,
        signInFetchers: new SignInFetchers()
    };


    const reducer = (state: StateRoot, action: ActionRoot): StateRoot => {
        let defaultResult = defaultReducer(state, action as Action);
        if(defaultResult) {return {...state, ...defaultResult};}
        switch (action.type) {
            case 'append-pages-recent': {
                state.pagesRecent.append(action.payload)
                return state;
            }
            case 'append-pages-by-price': {
                state.pagesByPrice.append(action.payload)
                return state;
            }
        }
        return state;
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    const signIn = new SignIn(state, dispatch);

    useEffect(() => {
        state.pagesRecent.onChange = () => {  dispatch({type: 'change'}) };
        state.pagesByPrice.onChange = () => {  dispatch({type: 'change'}) };
    });

    const moreRecent = () => {
        state.pagesRecent.more();
    }

    const moreByPrice = () => {
        state.pagesByPrice.more();
    }

    return (
        <>
            <Header signIn={signIn} />
            <div className="row my-4">
                <div className="md-12">
                    <h1 className={"text-center"}>Who Loves Wang?</h1>
                    <h2 className={"text-center subtitle"}>AI Generated Fan Pages for Wang Lovers</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <img src="https://who.loves.wang/files/images/4d3f2b9e-76b1-452b-8117-b9ae61144ebf/large.webp"
                         className="img-fluid rounded" alt="Wang the Possum"/>
                </div>
                <div className="col-md-9">
                    Wang is not your ordinary possum. He stands out with his long nose, pointy teeth, and sharp toenails. Not to forget, he proudly wears a gold necklace with the letter "W". Wang has a passion for money, loves munching on tacos, and enjoys spending time in the bathroom.
                </div>
            </div>
            <div className="row my-3">
                <div className="md-12 text-center">
                    <a href="/pages/new">
                        <button className={"btn btn-primary btn-lg"}>
                            Create a Fan Page
                        </button>
                    </a>
                </div>
            </div>
            {PageList(state.pagesByPrice, "Best Friends",
                () => {moreByPrice()}, state.pagesByPrice.isInProgress())}
            {PageList(state.pagesRecent, "New Friends",
                () => {moreRecent()}, state.pagesRecent.isInProgress())}
        </>
    );
}

export default Root;
